var map = {
	"./ai-alt-icon.json": [
		7518,
		7518
	],
	"./ai-icon.json": [
		3632,
		3632
	],
	"./angle-icon.json": [
		6003,
		6003
	],
	"./animation-icon.json": [
		4912,
		4912
	],
	"./api-icon.json": [
		6902,
		6902
	],
	"./archive-icon.json": [
		6448,
		6448
	],
	"./asset-icon.json": [
		1881,
		4262
	],
	"./audit-log-icon.json": [
		7066,
		7066
	],
	"./avatars-icon.json": [
		3024,
		3024
	],
	"./building-icon.json": [
		6670,
		6670
	],
	"./canvas-icon.json": [
		7482,
		7482
	],
	"./captions-icon.json": [
		8611,
		8611
	],
	"./change-icon.json": [
		3969,
		6350
	],
	"./color-icon.json": [
		4799,
		4799
	],
	"./copy-icon.json": [
		4169,
		4169
	],
	"./customer-management-icon.json": [
		1842,
		1842
	],
	"./documents-icon.json": [
		3328,
		3328
	],
	"./download-icon.json": [
		8918,
		8918
	],
	"./emails-icon.json": [
		5237,
		5237
	],
	"./estate-orbit-icon.json": [
		829,
		829
	],
	"./exclamation-mark-icon.json": [
		4969,
		4969
	],
	"./factory-icon.json": [
		6608,
		6608
	],
	"./faq-icon.json": [
		1390,
		1390
	],
	"./folder-icon.json": [
		4002,
		4002
	],
	"./funnel-icon.json": [
		1146,
		1146
	],
	"./help-icon.json": [
		2979,
		2979
	],
	"./home-icon.json": [
		9999,
		9999
	],
	"./homes-icon.json": [
		7722,
		7722
	],
	"./languages-icon.json": [
		6379,
		6379
	],
	"./list-icon.json": [
		2526,
		2526
	],
	"./loading-icon.json": [
		9866,
		9866
	],
	"./mail-plus-icon.json": [
		4223,
		6604
	],
	"./movie-edit-icon.json": [
		6703,
		6703
	],
	"./movie-icon.json": [
		5266,
		5266
	],
	"./movies-icon.json": [
		4145,
		4145
	],
	"./open-icon.json": [
		7454,
		7454
	],
	"./pages-icon.json": [
		7662,
		7662
	],
	"./pause-icon.json": [
		3804,
		3804
	],
	"./pencil-icon.json": [
		7889,
		7889
	],
	"./play-icon.json": [
		4412,
		4412
	],
	"./plus-icon.json": [
		7686,
		7686
	],
	"./polygon-icon.json": [
		1208,
		1208
	],
	"./preview-icon.json": [
		2834,
		2834
	],
	"./published-icon.json": [
		132,
		132
	],
	"./record-guide-icon.json": [
		6742,
		6742
	],
	"./record-icon.json": [
		3473,
		3473
	],
	"./record-stop-icon.json": [
		6966,
		6966
	],
	"./refresh-icon.json": [
		5803,
		5803
	],
	"./section-icon.json": [
		6607,
		6607
	],
	"./settings-icon.json": [
		3545,
		3545
	],
	"./share-icon.json": [
		4587,
		4587
	],
	"./sliders-icon.json": [
		7295,
		9676
	],
	"./social-media-icon.json": [
		9844,
		9844
	],
	"./support-icon.json": [
		3263,
		3263
	],
	"./template-icon.json": [
		7876,
		7876
	],
	"./trash-icon.json": [
		9412,
		9412
	],
	"./unpublished-icon.json": [
		3923,
		3923
	],
	"./upload-icon.json": [
		3301,
		3301
	],
	"./write-icon.json": [
		4823,
		4823
	],
	"./zoom-icon.json": [
		6251,
		6251
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1337;
module.exports = webpackAsyncContext;